// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../engines/components/BasePopUpLayer";
import BaseStatePlusSprite from "../../../engines/components/state/BaseStatePlusSprite";
import O1HD from "../../../engines/gameEngine";
import NodeUtil from "../../../engines/libs/NodeUtil";
import utilsModel from "../../../engines/libs/utilsModel";
import utilsView from "../../../engines/libs/utilsView";
import { FileKind } from "../../../modes/define/FileKind";
import ModelDialogLayer from "../../../modes/gameCommon/basic/ModelDialogLayer";
import { BUNDLE_SMALL_NAME } from "../../../modes/normalMode/BundleResourceConfig";
import HelpWifeLayer1Tools from "./HelpWifeLayer1Tools";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HelpWifeLayer1 extends BasePopUpLayer {

    @property({type:cc.Node,tooltip:"对话节点"})
    chatNode:cc.Node = null;

    @property(cc.Node)
    nodeHint: cc.Node = null;
    @property(cc.Node)
    nodeAd: cc.Node = null;

    @property(cc.Node)
    nodeTools: cc.Node = null;

    @property(cc.Node)
    nodeLockChain: cc.Node = null;

    @property(cc.Node)
    nodeWood: cc.Node = null; 
    @property(cc.Node)
    nodeKey: cc.Node = null; 
    @property(cc.Node)
    spr_chain: cc.Node = null; 

    private bShowHint = false;
    private touchNode: cc.Node = null;
    private oriPos: cc.Vec2 = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        O1HD.getModules().uiControlModule.hideLoading();
        this.chatNode.scale = 0;
        this.chatNode.active = true;
        this.showOneChat('相公，我就知道你一定会来救我的，我听话以后再也不乱跑了');
        this.refreshHintState();

        this.nodeTools.children.forEach((v)=> {
            v.on(cc.Node.EventType.TOUCH_START,this.onTouchStart,this);
            v.on(cc.Node.EventType.TOUCH_MOVE,this.onTouchMove,this);
            v.on(cc.Node.EventType.TOUCH_END,this.onTouchEnd,this);
            v.on(cc.Node.EventType.TOUCH_CANCEL,this.onTouchEnd,this);
        });
    }

    offToolsTouchEvent() {
        this.nodeTools.children.forEach((v)=> {
            v.off(cc.Node.EventType.TOUCH_START,this.onTouchStart,this);
            v.off(cc.Node.EventType.TOUCH_MOVE,this.onTouchMove,this);
            v.off(cc.Node.EventType.TOUCH_END,this.onTouchEnd,this);
            v.off(cc.Node.EventType.TOUCH_CANCEL,this.onTouchEnd,this);
        });
    }

    onTouchStart(event: cc.Event.EventTouch) {
        let curNode = event.getCurrentTarget();
        if (this.touchNode && this.touchNode != curNode) {
            return;
        }
        this.touchNode = curNode;
        curNode.zIndex = 1;
        this.oriPos = curNode.getPosition().clone();
        let sprItem = curNode.getChildByName('sprItem').getComponent(BaseStatePlusSprite);
        sprItem && sprItem.setFill(1);
    }

    onTouchMove(event: cc.Event.EventTouch) {
        let node = event.getCurrentTarget();
        if (this.touchNode && this.touchNode != node) {
            return;
        }
        let delta:cc.Vec2 = event.getDelta();
        node.x += delta.x;
        node.y += delta.y;
    }

    onTouchEnd(event: cc.Event.EventTouch) {
        this.endTalk();
        let node = event.getCurrentTarget();
        if (this.touchNode && this.touchNode != node) {
            return;
        }

        let polygon = this.nodeLockChain.getComponent(cc.PolygonCollider);
        let nodePos = node.convertToWorldSpaceAR(cc.v2(0,0));
        let touchPos = this.nodeLockChain.convertToNodeSpaceAR(nodePos);
        let points = polygon.points;
        touchPos.x -= polygon.offset.x;
        touchPos.y -= polygon.offset.y;

        let nodeRect = cc.rect(touchPos.x - node.width/2, touchPos.y - node.height/2, node.width, node.height);
        let bCollide = cc.Intersection.rectPolygon(nodeRect, points);
        let sprItem = node.getChildByName('sprItem').getComponent(BaseStatePlusSprite);
        let script = node.getComponent(HelpWifeLayer1Tools);
        if(bCollide){
            switch(script.tag) {
                case 0: {
                    node.setPosition(-62.607, -243.984);
                    cc.tween(node)
                    .to(0.35, {x: -62.607, y: -122.984})
                    .to(0.2, {x: -62.607, y: -243.028}, {easing: 'backOut'})
                    .call(()=> {
                        this.showLoseTalk();
                        O1HD.getManagers().soundMgr.playSound("hit_chain", null, BUNDLE_SMALL_NAME.waterCourse);
                    })
                    .delay(0.25)
                    .to(0.01, {x: -12.601, y: -315.553})
                    .call(()=> {
                        sprItem.setFill(2);
                    })
                    .delay(0.5)
                    .call(this.gameLose.bind(this))
                    .start();
                }
                break;
                case 1: {
                    node.setPosition(-41.073, -293.794);
                    sprItem.node.angle = 0;
                    cc.tween(sprItem.node)
                    .to(0.25, {angle: -70})
                    .to(0.1, {angle: 0}, {easing: cc.easing.backOut})
                    .call(()=> {
                        this.showLoseTalk();
                        sprItem.setFill(2);
                        O1HD.getManagers().soundMgr.playSound("wood_chain", null, BUNDLE_SMALL_NAME.waterCourse);
                    })
                    .delay(0.5)
                    .call(()=> {
                        // node.opacity = 0;
                        // node.setPosition(6.077, -349.389);
                    })
                    .delay(0.5)
                    .call(()=> {
                        this.gameLose();
                    })
                    .start();
                }
                break;
                case 2: {
                    node.scaleY = -1;
                    node.setPosition(108.005, -203.7);
                    sprItem.node.angle = -70;
                    cc.tween(sprItem.node)
                    .to(0.25, {angle: 0})
                    .to(0.1, {angle: -70}, {easing: cc.easing.backOut})
                    .call(()=> {
                        this.showLoseTalk();
                        sprItem.setFill(2);
                        O1HD.getManagers().soundMgr.playSound("hit_chain", null, BUNDLE_SMALL_NAME.waterCourse);
                    })
                    .delay(0.5)
                    .call(()=> {
                        // node.setPosition(178.016, -193.73);
                        // sprItem.node.angle = -90;
                        // node.opacity = 0;
                    })
                    .delay(0.5)
                    .call(()=> {
                        this.gameLose();
                    })
                    .start();
                }
                break;
                case 3: {
                    node.active = false;
                    O1HD.getManagers().soundMgr.playSound("key_chain", null, BUNDLE_SMALL_NAME.waterCourse);
                    cc.tween(this.spr_chain)
                    .to(0.25, {opacity: 0})
                    .delay(0.25)
                    .call(this.gameWin.bind(this))
                    .start();
                }
                break;
            }
        } else {
            if(script.tag == 2) {
                if (NodeUtil.isNodeOverlap(this.nodeWood, node, false)) {
                    this.nodeWood.active = false;
                    node.active = false;
                    this.touchNode = null;
                    this.oriPos = null;
                    O1HD.getManagers().soundMgr.playSound("wood_swrod", null, BUNDLE_SMALL_NAME.waterCourse);
                    this.nodeKey.active = true;
                    return; 
                }
            }

            cc.tween(node)
            .to(0.35, {x: this.oriPos.x, y: this.oriPos.y})
            .call(()=> {

                sprItem && sprItem.setFill(0);
            })
            .start();
        }

        node.zIndex = 0;
        this.touchNode = null;
        this.oriPos = null;
    }

    showLoseTalk() {
        this.showOneChat('啊~~~碰到伤口了~');
    }

    endTalk() {
        cc.Tween.stopAllByTarget(this.chatNode);
        this.chatNode.scale = 0;
    }

    gameLose() {
        this.offToolsTouchEvent();

        ModelDialogLayer.show('你将老婆的脚砸伤，匪徒乘机杀回来，抢走你1个亿', ()=> {
            O1HD.getServices().userSrv.setCoins(-100000000,true);
            this.destroyNode();
        }, ()=> {
            this.destroyNode();
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.HelpWifeLayer1
            );
        }
        , '挽回损失'
        , '离开'
        , true
        , null
        , '救老婆挽回损失'
        );
    }

    gameWin() {
        utilsView.openPopupLayer(
            'helpWife/prefab/HelpWifeLayer2'
            , BUNDLE_SMALL_NAME.waterCourse
            , null
            , null
            , null
            , (node)=> {
                cc.tween(this.node)
                .to(0.5, {opacity: 0})
                .call(()=> {
                    this.destroyNode();
                })
                .start();
                node.opacity = 0;
                cc.tween(node)
                .to(0.5, {opacity: 255})
                .start();
            }
        );
    }

    refreshHintState() {
        this.nodeHint.active = this.bShowHint;
        this.nodeAd.active = !this.bShowHint;
    }

    async showOneChat(chat:string){
        cc.Tween.stopAllByTarget(this.chatNode);
        this.chatNode.scale = 0;
        let lbChat:cc.Label = this.chatNode.getChildByName("label").getComponent(cc.Label);
        lbChat.string = chat;
        cc.tween(this.chatNode)
        .to(0.2,{scale:1},{easing:cc.easing.backOut})
        .delay(3)
        .to(0.2, {scale: 0},{easing:cc.easing.backIn})
        .start();
    }

    onClickHint() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (this.bShowHint) {
            this.openHint();
        } else {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.bShowHint = true;
                this.refreshHintState();
                this.openHint();
            },()=>{
     
            }, null, "救老婆看广告获得提示");
        }
    }

    openHint() {
        utilsView.openPopupLayer(
            'helpWife/prefab/HelpWifeHint'
            , BUNDLE_SMALL_NAME.waterCourse
            , this.node
            , {
                bHint1: true
            }
        );
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
